'use strict';

require('./less/calendar.less');

module.exports = require('./module');



/*****************
 ** WEBPACK FOOTER
 ** ./src/entry.js
 ** module id = 0
 ** module chunks = 0
 **/